<template>
  <div>
    <p class="text-description">
      <b> {{ getHeadPage() ? getHeadPage().mensaje_principal : '' }} </b>
    </p>
    <b-list-group>
      <b-list-group-item
        v-if="true"
        class="d-flex justify-content-between align-items-center item-list-service"
        @click="$router.push('/liquidacionPredial')"
      >
        Impuesto Predial
        <b-icon icon="house-door"></b-icon>
      </b-list-group-item>
      <b-list-group-item
        class="d-flex justify-content-between align-items-center item-list-service"
        @click="$router.push('/liquidacionInyCo')"
      >
        Impuesto Industria y Comercio
        <b-icon icon="building"></b-icon>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Home",
  components: {},  
  data: function() {
    return {
      data: null
    };
  },
  methods: {
    ...mapGetters("pse", {
      getHeadPage: "getHeadPage",
    })
  }
};
</script>
